import { getInstalledCallingProviders } from 'calling-integration-sdk-support/external-provider/operators/getInstalledCallingProviders';
// @ts-expect-error module not typed
import { getCallProviders } from 'calling-lifecycle-internal/call-provider/operators/getCallProvidersFromOmnibus';
/**
 * Returns a list of first and third calling providers.
 * @param props GetInstalledCallingSettingsProps
 * @returns list List<CallingProviderRecord>
 */
export const getInstalledCallingSettings = ({
  callsV1SettingsResponse,
  hasTwilioConnect
}) => {
  const firstPartyCallingProviders = getCallProviders({
    hasTwilioConnect
  });
  const installedCallingApplications = callsV1SettingsResponse && callsV1SettingsResponse.installedCallingSettings && callsV1SettingsResponse.installedCallingSettings.result && callsV1SettingsResponse.installedCallingSettings.result.results || [];
  const thirdPartyCallingProviders = getInstalledCallingProviders({
    installedCallingApplications
  });
  return firstPartyCallingProviders.concat(thirdPartyCallingProviders);
};